import { UserRole } from '@shared-enums';

import { MenuItemDefinition } from '../models/menu-item-definition.model';

export const ALL_MENU_ITEMS: MenuItemDefinition[] = [
  {
    id: 'home',
    name: 'Home',
    icon: 'home',
    route: '/home',
    roles: [UserRole.ADMIN, UserRole.SELLER, UserRole.SUPERVISOR],
  },
  {
    id: 'users',
    name: 'Users',
    icon: 'users',
    route: '/user',
    roles: [UserRole.ADMIN],
  },
  {
    id: 'tributary',
    name: 'Tributary Data',
    icon: 'bank',
    route: '/tributary',
    roles: [UserRole.ADMIN],
  },
  {
    id: 'providers',
    name: 'Providers',
    icon: 'dashboard',
    route: '/provider',
    roles: [UserRole.ADMIN, UserRole.SUPERVISOR, UserRole.WAREHOUSE],
  },
  {
    id: 'purchases',
    name: 'Purchases',
    icon: 'shopping',
    route: '/purchases',
    roles: [UserRole.ADMIN, UserRole.SUPERVISOR],
  },
  {
    id: 'accounts-payable',
    name: 'Accounts payable',
    icon: 'dashboard',
    route: '/accountsPayable',
    roles: [UserRole.ADMIN, UserRole.SUPERVISOR],
    children: [
      {
        id: 'accounts-payable-reports',
        name: 'Reports',
        icon: 'document',
        route: '/details_accounts_payable',
        roles: [UserRole.ADMIN, UserRole.SUPERVISOR],
      },
    ],
  },
  {
    id: 'commercial',
    name: 'Commercial Management',
    icon: 'cash',
    route: '/commercial',
    roles: [UserRole.ADMIN, UserRole.SUPERVISOR, UserRole.SELLER],
    children: [
      {
        id: 'sales',
        name: 'Sales',
        icon: 'cash',
        route: '/commercial/sales',
        roles: [UserRole.ADMIN, UserRole.SUPERVISOR, UserRole.SELLER],
      },
      {
        id: 'customers',
        name: 'Customers',
        icon: 'user',
        route: '/commercial/customers',
        roles: [UserRole.ADMIN, UserRole.SUPERVISOR, UserRole.SELLER],
      },
      {
        id: 'commercial-portfolio',
        name: 'Portfolio',
        icon: 'wallet',
        route: '/commercial/portfolio',
        roles: [UserRole.ADMIN, UserRole.SELLER, UserRole.SUPERVISOR],
        visibleInMenu: false,
      },
    ],
  },
  {
    id: 'sellers',
    name: 'Sellers',
    icon: 'seller',
    route: '/sellers',
    roles: [UserRole.ADMIN, UserRole.SUPERVISOR],
  },
  {
    id: 'portfolio',
    name: 'Portfolio',
    icon: 'wallet',
    route: '/portfolio',
    roles: [UserRole.ADMIN, UserRole.SELLER, UserRole.SUPERVISOR],
    children: [
      {
        id: 'portfolio-reports',
        name: 'Reports',
        icon: 'document',
        route: '/details_portfolio',
        roles: [UserRole.ADMIN, UserRole.SELLER, UserRole.SUPERVISOR],
      },
    ],
  },
  {
    id: 'treasury',
    name: 'Treasury',
    icon: 'dashboard',
    route: '/treasury',
    roles: [UserRole.ADMIN, UserRole.SELLER, UserRole.SUPERVISOR],
    children: [
      {
        id: 'treasury-advances',
        name: 'Advances',
        icon: 'wallet',
        route: '/treasury/advances',
        roles: [UserRole.ADMIN, UserRole.SELLER, UserRole.SUPERVISOR],
        visibleInMenu: false,
      },
      {
        id: 'treasury-transfers',
        name: 'Transfers',
        icon: 'refresh',
        route: '/treasury/transfers',
        roles: [UserRole.ADMIN, UserRole.SELLER, UserRole.SUPERVISOR],
        visibleInMenu: false,
      },
    ],
  },
  {
    id: 'inventory',
    name: 'Inventory',
    icon: 'dashboard',
    route: '/inventory',
    roles: [UserRole.ADMIN, UserRole.SUPERVISOR, UserRole.WAREHOUSE],
    children: [
      {
        id: 'inventory-movements',
        name: 'Movements',
        icon: 'refresh',
        route: '/inventory_movements',
        roles: [UserRole.ADMIN, UserRole.SUPERVISOR],
      },
      {
        id: 'inventory-jobs',
        name: 'Calculation operations',
        icon: 'refresh',
        route: '/inventory-jobs',
        roles: [UserRole.ADMIN, UserRole.SUPERVISOR],
      },
    ],
  },
  {
    id: 'imports',
    name: 'Imports',
    icon: 'dashboard',
    route: '/imports',
    roles: [UserRole.ADMIN, UserRole.SELLER, UserRole.SUPERVISOR],
  },
  {
    id: 'reports',
    name: 'Reports',
    icon: 'dashboard',
    route: '/reports',
    roles: [UserRole.ADMIN, UserRole.SUPERVISOR],
  },
  {
    id: 'analysis',
    name: 'Analysis',
    icon: 'dashboard',
    route: '/analysis',
    roles: [UserRole.ADMIN, UserRole.SELLER, UserRole.SUPERVISOR],
  },
  {
    id: 'warehouse',
    name: 'Warehouse',
    icon: 'dashboard',
    route: '/warehouse',
    roles: [UserRole.ADMIN, UserRole.SUPERVISOR, UserRole.WAREHOUSE],
    visibleInMenu: false,
  },
];
